export const CHAT_EVENT = {
  MOVE_TO_TASK: 'CHAT_EVENT_MOVE_TO_TASK',
};
